import { PermisosTabla } from './../models/permisosTabla';
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Mastertable } from "../models/mastertable";
import { endpointsURL } from "../constants/endpointsURL";
import { FieldStructure } from "./models/field-structure-mastertables";

@Injectable({
  providedIn: "root",
})
export class MastertablesService {
  env = environment.env;
  maintenanceMastertablesURL = endpointsURL.maintenanceMastertablesURL;
  permisosTablaURL = endpointsURL.permisosTablaURL;

  stateFilter: {
    mastertable;
    filtersTable;
    type;
  };

  fieldsStructure: FieldStructure[] = [];

  constructor(private httpClient: HttpClient) {}

  public list(type: string): Observable<string[]> {
    let params = new HttpParams().set("tipo", type);

    return this.httpClient.get<string[]>(
      `${this.env}${this.maintenanceMastertablesURL}list`,
      { params: params }
    );
  }

  public createMasterTable(mastertable: Mastertable): any {
    let params = new HttpParams();
    params = params.append("idtable", mastertable.name);

    params = params.append("tipo", mastertable.type);
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceMastertablesURL}list`,
      "",
      { params: params }
    );
  }
  public deleteMasterTable(mastertable: Mastertable): any {
    let params = new HttpParams();
    params = params.append("idtable", mastertable.name);

    params = params.append("tipo", mastertable.type);

    return this.httpClient.delete<any>(
      `${this.env}${this.maintenanceMastertablesURL}list`,
      { params: params }
    );
  }

  public listDataOfMasterTable(
    idtable,
    filtersTable,
    filtersSearch
  ): Observable<any> {
    let params = new HttpParams();

    filtersSearch.arrayKeys.forEach((e) => {
      params = params.append("filtroCampos", e);
    });

    filtersSearch.arrayValues.forEach((e) => {
      params = params.append("filtroValores", e);
    });

    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceMastertablesURL}${idtable}/list?${filtersTable}`,
      { params: params }
    );
  }

  public deleteDataOfMasterTable(ids: string[], idtable): Observable<any> {
    let params = "?";

    ids.forEach((e, index) => {
      if (index == 0) {
        params = params + "rowid=" + encodeURIComponent(e);
      } else {
        params = params + "&rowid=" + encodeURIComponent(e);
      }
    });
    return this.httpClient.delete<any>(
      `${this.env}${this.maintenanceMastertablesURL}${idtable}/edit${params}`
    );
  }

  public getDataOfMastertable(id, idtable): Observable<any> {
    id = encodeURIComponent(id);
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceMastertablesURL}${idtable}/edit?rowid=${id}`
    );
  }

  public createDataOfMastertable(data, idtable, file): Observable<any> {
    const fd = new FormData();
    if (!file) {
      fd.append("fichero", new Blob([], { type: "text/html" }));
    } else {
      fd.append("fichero", file);
    }
    fd.append("registroDto", JSON.stringify(data));
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceMastertablesURL}${idtable}/edit`,
      fd
    );
  }

  public updateDataOfMastertable(data, idtable, file) {
    const fd = new FormData();
    if (!file) {
      fd.append("fichero", new Blob([], { type: "text/html" }));
    } else {
      fd.append("fichero", file);
    }
    fd.append("registroDto", JSON.stringify(data));
    return this.httpClient.put<any>(
      `${this.env}${this.maintenanceMastertablesURL}${idtable}/edit`,
      fd
    );
  }

  public getCurrentFieldsStructure(): FieldStructure[] {
    return this.fieldsStructure;
  }

  public setCurrentFieldsStructure(fieldStructure): void {
    this.fieldsStructure = fieldStructure;
  }

  public getCurrentState(): any {
    return this.stateFilter;
  }

  public setCurrentState(state): any {
    this.stateFilter = state;
  }

  public getPermisosTablaByRole(idRole: string): Observable<PermisosTabla[]> {
    const params = new HttpParams().set("idRole", idRole);
    return this.httpClient.get<PermisosTabla[]>(
      `${this.env}${this.permisosTablaURL}listByPerfil`,
      { params }
    );
  }

  public getPermisosTablaByTable(table: string): Observable<PermisosTabla[]> {
    const params = new HttpParams().set("tabla", table);
    return this.httpClient.get<PermisosTabla[]>(
      `${this.env}${this.permisosTablaURL}listByTabla`,
      { params }
    );
  }

  public updatePermisosTablaForTable(permisos: PermisosTabla[]): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.permisosTablaURL}AddUpdate`,
      permisos
    );
  }
}
